import { ILocationConfigUnit } from '../../../../models/location-config.interface';
import { ILocationMapState } from '../../../../reducers/location-map-reducer/location-map.reducer';
import { LocationElements } from '../../../location-element';
import { JobsiteSetCommand } from '../../../../services/commands/jobsite/jobsite-set.command';
import { JobsiteLoadAddressCommand } from '../../../../services/commands/jobsite/jobsite-load-address.command';
import { JobsiteLoadSalesAreaCommand } from '../../../../services/commands/jobsite/jobsite-load-sales-area.command';
import { JobsiteLoadAddressEffects } from '../../../../effects/jobsite-effects/jobsite-load-address-effects/jobsite-load-address.effects';
import { JobsiteRenderMapEffects } from '../../../../effects/jobsite-effects/jobsite-render-map-effects/jobsite-render-map.effects';
import { JobsiteLoadSalesAreaEffects } from '../../../../effects/jobsite-effects/jobsite-load-sales-area-effects/jobsite-load-address.effects';
import { PurchaseOrderSetCommand } from '../../../../services/commands/purchase-order/purchase-order-set.command';
import { PurchaseOrderMandatoryEffects } from '../../../../effects/purchase-order-effects/purchase-order-mandatory.effects';
import { ReceivingPersonSetCommand } from '../../../../services/commands/receiving-person/receiving-person-set.command';
import { ReceivingPersonsLoadEffects } from '../../../../../../../shared/modules/receiving-person/redux/effects/receiving-person-load.effects';
import { SpecialInstructionsSetCommand } from '../../../../services/commands/special-instructions/special-instructions-set.command';
import { CmxMapConfig } from '../../../../../../../shared/models/cmx-map-config/cmx-map-config';
import { MAP_ADDRESS_TYPES } from '../../../../../../../shared/constants/map-address-types';
import { JobsiteLoadEffects } from '../../../../effects/jobsite-effects/jobsite-load-effects/jobsite-load.effects';

export const pickUp: { fields: ILocationConfigUnit[]; mapConfig: ILocationMapState } = {
  fields: [
    {
      name: LocationElements.JOBSITE,
      visible: true,
      disabled: false,
      required: true,
      onChange: [JobsiteSetCommand, JobsiteLoadAddressCommand, JobsiteLoadSalesAreaCommand],
      dynamicEffects: [
        JobsiteLoadEffects,
        JobsiteLoadAddressEffects,
        JobsiteRenderMapEffects,
        JobsiteLoadSalesAreaEffects,
      ],
    },
    {
      name: LocationElements.PURCHASE_ORDER,
      visible: true,
      disabled: false,
      required: false,
      onChange: [PurchaseOrderSetCommand],
      dynamicEffects: [PurchaseOrderMandatoryEffects],
    },
    {
      name: LocationElements.RECEIVING_PERSON,
      visible: true,
      disabled: false,
      required: false,
      onChange: [ReceivingPersonSetCommand],
      dynamicEffects: [ReceivingPersonsLoadEffects],
    },
    {
      name: LocationElements.SPECIAL_INSTRUCTION,
      visible: true,
      disabled: false,
      required: false,
      onChange: [SpecialInstructionsSetCommand],
    },
  ],
  mapConfig: {
    showMap: false,
    config: new CmxMapConfig(null, MAP_ADDRESS_TYPES.JOBSITE),
  },
};
